import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loadingCount = 0;
    private isSpinningSubject = new BehaviorSubject<boolean>(false);
    isSpinning$ = this.isSpinningSubject.asObservable();

    setIsSpinning(value: boolean) {
        if (value) {
            this.loadingCount++;
        } else if (this.loadingCount > 0) {
            this.loadingCount--;
        }
        if (this.loadingCount < 0) {
            this.loadingCount = 0;
        }
        this.isSpinningSubject.next(this.loadingCount > 0);
    }
}
